// extracted by mini-css-extract-plugin
export default {"custom_loader":"smallLoader_custom_loader__6cSiu","s6":"smallLoader_s6__YT96Z"};